class ScheduledReportSyncCell extends UITableViewCell
{
    private dateLabel:MUILabel = null;
    private statusLabel:MUILabel = null;
    private infoLabel:MUILabel = null;

    awakeFromHTML(){
        this.dateLabel = MUIOutlet(this, "date-lbl", "MUILabel");
        this.statusLabel = MUIOutlet(this, "status-lbl", "MUILabel");
        this.infoLabel = MUIOutlet(this, "info-lbl", "MUILabel");

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _item:IntegratorSync = null;
    set item(item:IntegratorSync){
        this._item = item;

        let ad = MUIWebApplication.sharedInstance().delegate as AppDelegate;
        this.dateLabel.text = item.date != null ? ad.dateTimeFormatter.stringFromDate(item.date) : "";

        if (item.status == 2) {
            this.statusLabel.text = MIOLocalizeString("SENT", "SENT");
            MUICoreLayerRemoveStyle(this.statusLabel.layer, "error");
            this.infoLabel.text = item.concept;
        }
        else {
            this.statusLabel.text = MIOLocalizeString("ERROR", "ERROR");
            MUICoreLayerAddStyle(this.statusLabel.layer, "error");
            this.infoLabel.text = item.error != null ? item.error : item.concept;
        }
    }
}
